import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SurveyChoicesModelInterface } from '../../features/user-personalization-survey/user-personalization-survey.model';

@Injectable({
    providedIn: 'root'
})
export class SurveyDataService {
    private surveyDataSubject = new BehaviorSubject<SurveyChoicesModelInterface | null>(null);
    private userSurveyDataSubject = new BehaviorSubject<SurveyChoicesModelInterface | null>(null);

    public surveyData$ = this.surveyDataSubject.asObservable();
    public userSurveyData$ = this.userSurveyDataSubject.asObservable();

    setSurveyData(data: SurveyChoicesModelInterface): void {
        this.surveyDataSubject.next(data);
    }

    setUserSurveyData(data: SurveyChoicesModelInterface): void {
        this.userSurveyDataSubject.next(data);
    }

    getSurveyData(): SurveyChoicesModelInterface | null {
        return this.surveyDataSubject.value;
    }

    getUserSurveyData(): SurveyChoicesModelInterface | null {
        return this.userSurveyDataSubject.value;
    }

    clearData(): void {
        this.surveyDataSubject.next(null);
        this.userSurveyDataSubject.next(null);
    }
}
